import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { BoxForm, TextField } from 'components/Form'
import { SectionHeader } from 'components/Header'
import { TextLink } from 'components/Link'
import Paper from 'components/Paper'
import { useAuthUser } from 'features/user'
import { useAbility } from 'providers/casl'
import { KNOWLEDGE_BASE_URL } from '../constants'
import { Schema } from '../schema'

type Props = {
  isPsVariableKeyValueCreated: boolean
}

export const PrebidVariableSection = ({
  isPsVariableKeyValueCreated,
}: Props): React.JSX.Element => {
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'defaults.prebid.prebidVariable',
  })
  const { t: tC } = useTranslation('common')
  const { control } = useFormContext<Schema>()

  const {
    helpers: { isGamConnected },
  } = useAuthUser()
  const ability = useAbility()
  const cannotUpdate =
    ability.cannot('update', 'GlobalSetupFeature-defaults-prebidStack') ||
    ability.cannot('update', 'GlobalSetupField-prebidVariableName')

  return (
    <Paper
      data-cy='section-prebid-variable'
      variant='cream'
    >
      <BoxForm>
        <SectionHeader
          subtitle={t('subtitle')}
          subtitleEndAdornment={
            <TextLink
              link={{
                title: tC('learnMore'),
                url: KNOWLEDGE_BASE_URL.PREBID_VARIABLE,
              }}
            />
          }
          title={t('title')}
        />

        <TextField
          control={control}
          disabled={cannotUpdate || !isGamConnected || !isPsVariableKeyValueCreated}
          label={t('prebidVariableName.label')}
          name='prebidVariableName'
          {...(!isGamConnected && {
            tooltip: {
              content: t('prebidVariableName.errors.gamConnectionRequired'),
            },
          })}
          {...(isGamConnected &&
            !isPsVariableKeyValueCreated && {
              tooltip: {
                content: t('prebidVariableName.errors.psVariableKeyValueRequired'),
              },
            })}
        />
      </BoxForm>
    </Paper>
  )
}
